import * as React from 'react';
import { createPortal } from 'react-dom';
import LayersContext from './LayersContext';
import { jsx as _jsx } from "react/jsx-runtime";
function NewLayer({
  host: hostProp = 'overlays',
  children
}) {
  const context = React.useContext(LayersContext);
  if (!globalThis.document) {
    return null;
  }
  const host = context?.[hostProp] || globalThis.document?.body;
  return /*#__PURE__*/createPortal(/*#__PURE__*/_jsx("div", {
    children: children
  }), host);
}
export default NewLayer;